import { ICodWithSubtype } from '../cod-with-subtype.interface';
import { ICodDomestic } from './cod-domestic.interface';

export interface ICodDomesticWithSubtype<T extends { issueType: string }> extends ICodDomestic, ICodWithSubtype<T> {}
